<template>
    <div>
        <span v-if="showLabel">{{field.label}}:</span>
        {{ getFieldValue }}
    </div>
</template>

<script>
  export default {
    props: {
      item: {
        type: Object,
        default: null
      },
      field: {
        type: Object,
        required: true
      },
      showLabel: {
        default: false,
        type: Boolean
      }
    },
    computed: {
      getFieldValue () {
        if (this.item === null) {
          return ''
        }
        const value = this.item[this.field.handle]
        return typeof value.value !== 'undefined' ? value.value : value
      }
    },
    name: 'TextColumn'
  }
</script>

<style scoped>

</style>